module.exports = __webpack_public_path__ + "static/9-763d597bbbd94d1e3252f1c730408c52.jpeg";